export default "__VITE_ASSET__BJFgXKjY__"